import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ProductAttributes = (props: {
  caseDimensions: string | undefined,
  orderCategory: string | undefined,
  productCategory: string | undefined,
  vat: number | undefined,
  weight: number | undefined,
  casesPerPallet: number | undefined,
  casesPerLayer: number | undefined,
  minShippingLife: number | undefined,
  minShelfLife: number | undefined,
  singlePick: boolean | undefined,
  caseSize: number | undefined,
}) => {
  const { t } = useTranslation('productDetails');
  const theme = useTheme();

  return (
    <TableContainer sx={{ borderRadius: '12px' }}
      component='div'>
      <Table size="small">
        <TableHead sx={{ backgroundColor: theme.palette.custom.gray[200] }}>
          <TableRow>
            <TableCell width={'50%'}>
              {t('attribute')}
            </TableCell>
            <TableCell>
              {t('value')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.caseDimensions')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.caseDimensions}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.orderCategory')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.orderCategory}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.productCategory')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.productCategory}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.singlePick')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.singlePick === undefined ? '' : props.singlePick ? 'Y' : 'N'}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.vat')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.vat}%
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.weight')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.weight} KG
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.caseSize')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.caseSize}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.casesPerPallet')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.casesPerPallet}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.casesPerLayer')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.casesPerLayer}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.minimumShippingLife')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.minShippingLife} {t('productAttributesTab.days')}
              </Typography>
            </TableCell>
          </TableRow>
      
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('productAttributesTab.minimumShelfLife')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.minShelfLife} {t('productAttributesTab.days')}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProductAttributes;